import { useState, useEffect, useContext } from 'react';
import { useTheme } from '@mui/material';
import { Context } from './CreateNotice';
import PropTypes from 'prop-types';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import SortButton from './common/SortButton';
import NoticeTemplatesTable from './common/NoticeTemplatesTable';
import generateNoticeFrameId from '../common/generateNoticeFrameId';
import { SORT_CATEGORIES } from '../common/constants';
import { isVerticalIpadMini } from '../common/responsiveUtils';
import { MESSAGES } from '../common/messages';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';

const SelectNoticeTemplateDialog = (props) => {
  const { palette, typography } = useTheme();
  const styles = {
    createNoticeFromCheckedNoticeButton: {
      ...typography.body14bold,
      width: '250px',
      height: '44px',
      backgroundColor: 'white',
      padding: '0px 16px 0px 24px',
      border: '1px solid ' + palette.primary.main,
    },
    noTemplateMessage: {
      ...typography.body16bold,
      color: palette.darkgray,
      align: 'center',
    },
  };

  const { setNoticeArray } = useContext(Context);
  const { masterData } = props;

  const [templates, setTemplates] = useState([]);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('/v1/notice-templates');
        setTemplates(data);
      } catch (err) { }
    };
    fetchData();
  }, []);

  const handleClose = () => {
    props.setOpen(false);
    setSelectedTemplateIds([]);
  };

  const getStationName = (sectionCode, stationCode) => {
    return masterData.find((section) => section.code === sectionCode)?.stations
      .find((stations) => stations.code === stationCode)?.name;
  };

  const handleSelect = (selectedTemplateIds) => {
    try {
      selectedTemplateIds.map((templateId, index) => {
        const selectTemplate = templates.find((template) => template._id === templateId);
        setNoticeArray((prevNoticeArray) => {
          const sectionCode = selectTemplate.section.code;
          const startStationCode = selectTemplate.startStation.code;
          const endStationCode = selectTemplate.endStation.code;
          return [...prevNoticeArray, {
            id: generateNoticeFrameId(index),
            sectionCode,
            sectionName: masterData.find((section) => section.code === sectionCode).name,
            noticeCategoryCode: selectTemplate.noticeCategoryCode,
            noticeTypeCode: selectTemplate.noticeTypeCode,
            startStationCode,
            startStationName: getStationName(sectionCode, startStationCode),
            endStationCode,
            endStationName: getStationName(sectionCode, endStationCode),
            reasonCode: selectTemplate.reasonCode,
            isImmediate: true,
            delayMin: 0,
            delaySec: 0,
          }];
        });
      });
      handleClose();
      enqueueSnackbar(MESSAGES.TEMPLATE_APPLIED);
    } catch (err) { }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      fullWidth
      maxWidth='lg'
      PaperProps={{
        sx: {
          height: '668px',
        },
      }}
    >
      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        通告テンプレートを選択
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: isVerticalIpadMini() ? '0px 16px' : '0px 96px' }}>
        <Stack direction='row' sx={{ padding: '16px 0' }}>
          <Button variant="outlined"
            sx={styles.createNoticeFromCheckedNoticeButton}
            startIcon={<CheckIcon />}
            disabled={!selectedTemplateIds.length}
            onClick={() => {
              handleSelect(selectedTemplateIds);
            }}
          >
            選択したテンプレートを利用
          </Button>
          <SortButton
            items={[
              SORT_CATEGORIES.SECTION_NUMBER_ASC,
              SORT_CATEGORIES.SECTION_NUMBER_DESC,
              SORT_CATEGORIES.NOTICE_CATEGORIES_ASC,
              SORT_CATEGORIES.NOTICE_CATEGORIES_DESC,
              SORT_CATEGORIES.CREATED_ASC,
              SORT_CATEGORIES.CREATED_DESC,
            ]}
            initialItem={SORT_CATEGORIES.CREATED_DESC}
            tableData={templates}
            setTableData={setTemplates}
          />
        </Stack>
        <TableContainer component={Paper} sx={{ height: '496px', overflowY: 'unset' }}>
          <NoticeTemplatesTable
            templates={templates}
            view='dialog'
            selectedTemplateIds={selectedTemplateIds}
            setSelectedTemplateIds={setSelectedTemplateIds}
          />
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default SelectNoticeTemplateDialog;

SelectNoticeTemplateDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  masterData: PropTypes.array,
};
